import { FC, useMemo } from 'react';
import { TEPSCard } from '@xeppt/xeppt-sdk/types';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import visa from '@svg/visa.svg';
import mastercard from '@svg/mastercard.svg';
import amex from '@svg/amex.svg';

import { formatDate, prettifyCardStars } from '@utils/index';

interface IProps {
    card: TEPSCard;
}

const CardSection: FC<IProps> = ({ card }) => {
    // const { t } = useTranslation('sections', {
    //     keyPrefix: 'manage_accounts.bank'
    // });
    const image = useMemo(() => {
        if (card.card_brand === 'visa' || card.card_brand === 'VISA') {
            return visa;
        } else if (card.card_brand === 'mastercard' || card.card_brand === 'MASTERCARD') {
            return mastercard;
        } else if (card.card_brand === 'amex' || card.card_brand === 'AMEX') {
            return amex;
        }
        return visa;
    }, [card]);
    return (
        <div className={styles.wrapper}>
            {card?.card_brand}
            <img className={styles.brand} src={image} alt="" />
            <div className={styles.row}>
                <div>
                    <Typography className={styles.title} variant="body2" weight="bold">
                        Card number
                    </Typography>
                    <Typography className={styles.description} variant="body2">
                        {prettifyCardStars(card.card_number)}
                    </Typography>
                </div>
                <div>
                    <Typography className={styles.title} variant="body2" weight="bold">
                        Good thru
                    </Typography>
                    <Typography className={styles.description} variant="body2">
                        {formatDate(card.expires_at, 'MM/YY')}
                    </Typography>
                </div>
            </div>
            <div>
                <Typography className={styles.title} variant="body2" weight="bold">
                    Cardholder name
                </Typography>
                <Typography className={styles.description} variant="body2">
                    {card.card_holder_name}
                </Typography>
            </div>
        </div>
    );
};

export default CardSection;
